var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-subheader',_vm._g({staticClass:"text-caption pa-0",staticStyle:{"height":"auto"}},!_vm.disabled && _vm.$listeners),[_c('a',{class:[_vm.disabled && 'text--disabled', 'text-decoration-underline link--text font-italic'],domProps:{"textContent":_vm._s(_vm.$i18n.t(_vm.translationPath))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }